// extracted by mini-css-extract-plugin
module.exports = {"row":"ItemDetailRow_row__3uI6x","label":"ItemDetailRow_label__3xDI1","data":"ItemDetailRow_data__3dqL4"};